<template>
	<v-slide-item>
		<v-btn	class="customVBtn"
				:block="$_amSldItm_styleMenuButtonBlock"
				:color="$_amSldItm_styleMenuButtonColor"
				:dark="$_amSldItm_styleMenuButtonDark"
				:depressed="$_amSldItm_styleMenuButtonDepressed"
				:elevation="$_amSldItm_styleMenuButtonElevation"
				:large="$_amSldItm_styleMenuButtonLarge"
				:light="$_amSldItm_styleMenuButtonLight"
				:outlined="$_amSldItm_styleMenuButtonOutlined"
				:rounded="$_amSldItm_styleMenuButtonRounded"
				:small="$_amSldItm_styleMenuButtonSmall"
				:text="$_amSldItm_styleMenuButtonFlat"
				@click="openLink(contents[contentKey].link)">
			<v-row no-gutters align="center">
				<template v-if="!isFalse(contents[contentKey].icon)">
					<v-col class="center">
						<v-icon :color="contents[contentKey].iconColor"
								v-text="contents[contentKey].icon" />
					</v-col>
				</template>
				<template v-if="!isFalse($_amSldItm_langContentTitle(contents[contentKey]))">
					<v-col class="ml-2 center">
						<span	class="overline"
								v-html="$_amSldItm_langContentTitle(contents[contentKey])" />
					</v-col>
				</template>
				<template v-if="debugMode">
					<v-col class="ml-2" cols="auto">
						<debugger-order-alert :order="contents[contentKey].order" />
					</v-col>
				</template>
			</v-row>
		</v-btn>
	</v-slide-item>
</template>

<script>
	export default {
		name: 'AppMenuSlideItem',
		props: {
			contentKey: String,
			contents: Object,
			inits: Object
		},
		computed: {
			// lang
			$_amSldItm_langContentTitle() {
				const self_ = this;
				return contentVals => {
					if(self_.isFalse(contentVals.title)) { return null }
					return self_.getLangsVal(contentVals.title)
				}
			},
			// style
			$_amSldItm_styleMenuButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'menuButton')
			},
			$_amSldItm_styleMenuButtonBlock() {
				const self_ = this;
				const button_ = self_.$_amSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_amSldItm_styleMenuButtonColor() {
				const self_ = this;
				const button_ =self_.$_amSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_amSldItm_styleMenuButtonDark() {
				const self_ = this;
				const button_ = self_.$_amSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_amSldItm_styleMenuButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_amSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_amSldItm_styleMenuButtonElevation() {
				const self_ = this;
				const button_ = self_.$_amSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_amSldItm_styleMenuButtonFlat() {
				const self_ = this;
				const button_ = self_.$_amSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_amSldItm_styleMenuButtonLarge() {
				const self_ = this;
				const button_ = self_.$_amSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_amSldItm_styleMenuButtonLight() {
				const self_ = this;
				const button_ = self_.$_amSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_amSldItm_styleMenuButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_amSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_amSldItm_styleMenuButtonRounded() {
				const self_ = this;
				const button_ = self_.$_amSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_amSldItm_styleMenuButtonSmall() {
				const self_ = this;
				const button_ = self_.$_amSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			}
		}
	}
</script>

<style scoped>
</style>
